// Shared styled-components for menu categorization UI (used by MenuCategorizationPanel)
import styled from "styled-components";

const categoryBackground = (color) => {
  if (color === "#2E7D32") return "rgba(46, 125, 50, 0.15)";
  if (color === "#4CAF50") return "rgba(76, 175, 80, 0.1)";
  if (color === "#FFC107") return "rgba(255, 193, 7, 0.1)";
  if (color === "#d32f2f") return "rgba(211, 47, 47, 0.1)";
  return "#F5F5F5";
};

export const SectionHeaderContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 12px;
  padding: 12px;
  background-color: ${(props) => categoryBackground(props.color)};
  border-radius: 8px;
  border-left: 4px solid ${(props) => props.color || "#757575"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SectionHeaderTitle = styled.h5`
  color: ${(props) => props.color || "#212121"};
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  flex: 1;
`;

export const BulkActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const BulkActionButton = styled.button`
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
  background: white;
  color: #212121;
  font-weight: 500;

  &:hover {
    background: #f5f5f5;
    border-color: #bdbdbd;
  }

  &:focus {
    outline: 2px solid ${(props) => props.color || "#4CAF50"};
    outline-offset: 2px;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const FooterActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 24px;
  padding: 12px;
  background-color: ${(props) => categoryBackground(props.color)};
  border-radius: 8px;
  border-left: 4px solid ${(props) => props.color || "#757575"};
`;

export const CollapseButton = styled.button`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
  background: white;
  color: #212121;
  font-weight: 500;
  margin-left: auto;

  &:hover {
    background: #f5f5f5;
    border-color: #bdbdbd;
  }

  &:focus {
    outline: 2px solid ${(props) => props.color || "#4CAF50"};
    outline-offset: 2px;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const SectionSummary = styled.div`
  font-size: 14px;
  color: #757575;
  margin-top: 8px;
`;

export const MenuSectionHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #424242;
  margin-top: 16px;
  margin-bottom: 8px;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border-left: 3px solid #9e9e9e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const SectionHeaderText = styled.span`
  flex: 1;
`;

export const SectionHeaderInput = styled.input`
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #424242;
  padding: 4px 8px;
  border: 1px solid #4caf50;
  border-radius: 4px;
  outline: none;
  background: white;

  &:focus {
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
  }
`;

export const AddItemButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 16px 0;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 2px dashed #4caf50;
  background: white;
  color: #4caf50;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    background: rgba(76, 175, 80, 0.05);
  }

  &:focus {
    outline: 2px solid #4caf50;
    outline-offset: 2px;
  }

  &:active {
    transform: scale(0.98);
  }

  i {
    font-size: 16px;
  }
`;

export const SectionEditButton = styled.button`
  background: none;
  border: none;
  color: #9e9e9e;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #4caf50;
    background: rgba(76, 175, 80, 0.1);
  }

  &:focus {
    outline: 2px solid #4caf50;
    outline-offset: 2px;
  }
`;
